let tracks = {
    Menu: {
        filename: 'life-is-full-of-joy.ogg',
        volume: 0.15,
        data: null,
        canPlay: false,
        loop: true
    }
}

function PlayTrack(track) {
    if (tracks[track] && tracks[track].data && tracks[track].canPlay) {
        if (tracks[track].isPlaying) {
            tracks[track].data.currentTime = 0
        } else {
            tracks[track].data.volume = tracks[track].volume
            tracks[track].data.play()
        }
    } else if (tracks[track]) {
        LoadTrack(track, true)
    }
}

function StopTrack(track) {
    if (tracks[track] && tracks[track].data) {
        //tracks[track].data.currentTime = 0
        tracks[track].data.pause()
    }
}

function LoadTrack(track, autoplay) {
    if (tracks[track]) {
        tracks[track].data = new Audio('./music/' + tracks[track].filename)
        tracks[track].data.addEventListener('canplaythrough', (e) => {
            tracks[track].canPlay = true
            if (autoplay) {
                tracks[track].data.volume = tracks[track].volume
                tracks[track].data.play()
            }
        })
        tracks[track].data.addEventListener('playing', (e) => {
            tracks[track].isPlaying = true
        })
        tracks[track].data.addEventListener('play', (e) => {
            tracks[track].isPlaying = true
        })
        tracks[track].data.addEventListener('ended', (e) => {
            tracks[track].isPlaying = false
            if (tracks[track].loop) {
                PlayTrack(track)
            } else {
                StopTrack(track)
            }
        })
        tracks[track].data.addEventListener('pause', (e) => {
            tracks[track].isPlaying = false
        })
    }
}


export { PlayTrack, LoadTrack, StopTrack }